import { render, staticRenderFns } from "./Admisioncita.vue?vue&type=template&id=48bb090a"
import script from "./Admisioncita.vue?vue&type=script&lang=js"
export * from "./Admisioncita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports